





































































































































import Vue from 'vue'
import {latLng} from "leaflet";
import {mapState} from 'vuex'
import Leaflet from 'leaflet'
import {LMap, LPopup} from "vue2-leaflet";

export default Vue.extend({
  name: 'Map',
  computed: {
    ...mapState(['data',]),
    // headers() {
    //   return Object.values(this.data.datesData).map((x: any) => x.headers)
    // },
  },
  data: () => ({
    zoom: 7.3,
    center: latLng(42.2510513, 24.8420651),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    markerClusterOptions: {
      maxClusterRadius: 0,
      iconCreateFunction: function (cluster: any) {
        const childCount = cluster.getChildCount();
        const availability = cluster.getAllChildMarkers().reduce(
            (a: number, b: any) => {
              return a + b.options.availability
            }, 0) / childCount
        let c = ' marker-cluster-';
        if (availability < .05) {
          c += 'large';
        } else if (availability < .15) {
          c += 'medium';
        } else {
          c += 'large';
        }
        return new Leaflet.DivIcon({
          html: '<div><span>' + childCount + '</span></div>',
          className: 'marker-cluster' + c,
          iconSize: new Leaflet.Point(40, 40)
        });
      }
    },
    icons: {
      green: new Leaflet.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      yellow: new Leaflet.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      orange: new Leaflet.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      red: new Leaflet.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
    },
    centreId: null,
    dialog: false,
  }),
  methods: {
    getColour(value: number) {
      // console.log(value)
      if (value === 0) {
        return 'red'
      } else if (value < .10) {
        return 'orange'
      } else if (value < .35) {
        return 'yellow'
      } else {
        return 'green'
      }

    },
    getHeaders(centreId: number) {
      const data = this.data.datesData[centreId]
      console.log(data)
      return []
    },
    dialogOpen(event: any) {
      this.dialog = true
      this.centreId = event.target.options.centre
      this.$store.dispatch('fetchDates', {centre: this.centreId})
    },
    localtime(x: string) {
      const date = new Date(x)
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString(undefined, {hour12: false})}`
    },
    test(a: any) {
      console.log(a, "error")
    },
    goToLocation() {
      if (!navigator.geolocation) {
        console.log('Geolocation is not supported by your browser');
      } else {
        console.log('Locating…');
        navigator.geolocation.getCurrentPosition((position) => {

          (this.$refs.map as LMap).mapObject.flyTo(new Leaflet.LatLng(position.coords.latitude, position.coords.longitude), 12);

        });
      }
    },
    toggleLegend() {
      this.data.legendHidden = !this.data.legendHidden
    },
    refresh() {
      this.data.refreshingData = true;
      this.$store.dispatch('fetch_data');
    },
    // doSomethingOnReady() {
    //   (this.$refs.map as LMap).mapObject.on('popupopen', (e: any) => {
    //     this.$store.dispatch('fetchDates', {centre: e.popup.options.centre});
    //   });
    //   // for (const popup of this.$refs.popups as Array<LPopup>) {
    //   //   console.log(popup.mapObject)
    //   //   popup.mapObject.on('popupopen', (a) => console.log(a))
    //   // }
    // }
  },
})
